import { type FC } from "react";
import { Icon } from "@root/shared/components/Icon";
import { Label as NewLabel } from "@root/shared/components/Label/legacy";
import * as styles from "./styles.css";

type AwardsLabel = {
  rank: string;
  displayTextShort: string;
};

export type FeatureLabelProps = {
  featureLabels: {
    selected?: string[];
    unselected?: string[];
  };
  awards2026Labels: AwardsLabel[];
  awards2025Labels: AwardsLabel[];
  awards2024Labels: AwardsLabel[];
  awards2023Labels: AwardsLabel[];
  awards2022Labels: AwardsLabel[];
  awardsLabels: AwardsLabel[];
  showAwardsLabelFlag?: boolean;
  isContractRunning: boolean;
  isReviewLabel: boolean;
};

export const FeatureLabels: FC<FeatureLabelProps> = ({
  featureLabels: { selected, unselected },
  awards2026Labels,
  awards2025Labels,
  awards2024Labels,
  awards2023Labels,
  awards2022Labels,
  awardsLabels,
  showAwardsLabelFlag,
  isContractRunning,
  isReviewLabel,
}) => {
  // Rejob Awardsのラベルは最新のものを優先して表示する
  const awardsLabel = getFirstValidAwardLabel({
    awards2026Labels,
    awards2025Labels,
    awards2024Labels,
    awards2023Labels,
    awards2022Labels,
    awardsLabels,
  });
  return (
    <ul className={styles.labelList}>
      {/* awardsラベル 最も優先度の高い一つのみ表示 */}
      {showAwardsLabelFlag && awardsLabel && (
        <li
          className={`${styles.labelAwardsOuter} cassette-header__label-item cassette-header__label-item--awards`}
          key={awardsLabel.displayTextShort}
        >
          <span
            className={`${styles.labelAwards} ${styles.labelAwardsVariants[awardsLabel.rank as keyof typeof styles.labelAwardsVariants]}`}
          >
            {awardsLabel.displayTextShort}
          </span>
        </li>
      )}
      {/* 口コミありラベル */}
      {isReviewLabel && (
        <li className={styles.reviewLabel}>
          <NewLabel color="lightOrange" size="extraSmall" filledType="outlined" round="slight" bold>
            <span className={styles.reviewLabelInner}>
              <Icon name="message" fontSize="12px" />
              口コミあり
            </span>
          </NewLabel>
        </li>
      )}
      {/* クエリに含まれるラベル */}
      {selected &&
        selected.map((item) => (
          <li className={styles.searchedLabelFeature} key={item}>
            {item}
          </li>
        ))}
      {/* クエリに含まれないラベル */}
      {unselected &&
        unselected.map((item) => (
          <li className={styles.labelFeature} key={item}>
            {item}
          </li>
        ))}
      {!isContractRunning && <li className={styles.labelFeature}>募集終了</li>}
      <span className={styles.remaining}>...</span>
    </ul>
  );
};

const getFirstValidAwardLabel = ({
  awards2026Labels,
  awards2025Labels,
  awards2024Labels,
  awards2023Labels,
  awards2022Labels,
  awardsLabels,
}: Pick<
  FeatureLabelProps,
  | "awards2026Labels"
  | "awards2025Labels"
  | "awards2024Labels"
  | "awards2023Labels"
  | "awards2022Labels"
  | "awardsLabels"
>): AwardsLabel | undefined => {
  const allLabels = [
    ...awards2026Labels,
    ...awards2025Labels,
    ...awards2024Labels,
    ...awards2023Labels,
    ...awards2022Labels,
    ...awardsLabels,
  ];
  return allLabels.find((label) => Boolean(label.rank && label.displayTextShort));
};
